import React from 'react';

import PropTypes from 'prop-types';

import { DataItem } from 'components/DataItem/DataItem';
import { SubTitle } from 'components/SubTitle/SubTitle';

import './RegionDetails.scss';

export const RegionDetails = ({ regionsDataOptions }) => (
  <div className="regionDetails">
    {(regionsDataOptions || []).map((item, index) => (
      <div key={index} className="regionDetailsItem">
        <SubTitle text={item?.option?.subTitle} id={item?.key} notFramed />
        <div>{item?.option?.subTitleDescription}</div>
        <div>{item?.option?.subTitleSecondDescription}</div>
        <div className="regionImageContainer">
          {item?.option?.mapImageName && (
            // eslint-disable-next-line global-require, import/no-dynamic-require
            <img alt="Map" src={require(`assets/pics/${item?.option?.mapImageName}`)} />
          )}
        </div>
        <div className="dataItem-container">
          {(item?.option?.contactDetails?.data || []).map((value) => (
            // phone number or email, it should be unique
            <DataItem key={value.data.value} data={value} />
          ))}
        </div>
      </div>
    ))}
  </div>
);

RegionDetails.propTypes = {
  regionsDataOptions: PropTypes.array.isRequired,
};
